// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"cbe7b4f5","232":"3a9aa9bd","237":"e7e097b0","526":"680ad6a9","787":"ba7e20ca","872":"e0b4250e"}[chunkId] + ".chunk.js";
};